import type { Entity } from '@backstage/catalog-model';
import type { FC } from 'react';

import {
  InspectEntityDialog,
  UnregisterEntityDialog,
} from '@backstage/plugin-catalog-react';
import { satisfyLintIgnoreHookValue } from '@ipen-portal/plugin-common-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

import { EntityContextMenu as BackstageEntityContextMenu } from '../../../vendor/Backstage/EntityContextMenu';

type Props = {
  entity?: Entity;
};

export const EntityContextMenu: FC<Props> = ({ entity }) => {
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [inspectionDialogOpen, setInspectionDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const cleanUpAfterRemoval = () => {
    setConfirmationDialogOpen(false);
    setInspectionDialogOpen(false);
    void navigate('/');
  };

  useEffect(() => {
    satisfyLintIgnoreHookValue(location.pathname);
    setConfirmationDialogOpen(false);
    setInspectionDialogOpen(false);
  }, [location.pathname]);

  if (!entity) return null;

  return (
    <>
      <BackstageEntityContextMenu
        onInspectEntity={() => setInspectionDialogOpen(true)}
        onUnregisterEntity={() => setConfirmationDialogOpen(true)}
      />
      <UnregisterEntityDialog
        entity={entity}
        onClose={() => setConfirmationDialogOpen(false)}
        onConfirm={cleanUpAfterRemoval}
        open={confirmationDialogOpen}
      />
      <InspectEntityDialog
        entity={entity}
        onClose={() => setInspectionDialogOpen(false)}
        open={inspectionDialogOpen}
      />
    </>
  );
};
